import { render, staticRenderFns } from "./EventNotifyList.vue?vue&type=template&id=6ca2f43a&scoped=true&"
import script from "./EventNotifyList.vue?vue&type=script&lang=js&"
export * from "./EventNotifyList.vue?vue&type=script&lang=js&"
import style0 from "./EventNotifyList.vue?vue&type=style&index=0&id=6ca2f43a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2f43a",
  null
  
)

export default component.exports